// pages/FormViewerPage/sections/ProductImageSection.tsx — Main product image (fade-in on load)
// imageOverride: foto varian terpilih (kalau ada) menggantikan mainImage.
import React from 'react';
import { getOptimizedImageUrl } from '../../../utils/imageUtils';
import SafeImage from '../../../components/SafeImage';

export const ProductImageSection: React.FC<{ form: any; imageOverride?: string | null; setImageLoaded: (v: boolean) => void; blockSpacingClass: string }> = ({ form, imageOverride, setImageLoaded, blockSpacingClass }) => {
    const src = imageOverride || form.mainImage;
    return (
        <div className={blockSpacingClass}>
            {src ? <SafeImage priority="high" cacheBust={false} src={getOptimizedImageUrl(src, { width: 640, quality: 70 }) || src} alt={form.title} className="w-full max-h-[400px] min-h-[240px] rounded-lg" imgClassName="object-contain max-h-[400px]" onLoad={() => setImageLoaded(true)} />
                : <div className="h-8"></div>}
        </div>
    );
};
